import { Component } from 'react'

class SkeletonRadio extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: '',
      floatMenu: false,
      width: 0,
      height: 0,
      flagPotraitPhone: false
    }
  }

  componentDidMount = async () => {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
    // console.log('innerWidth = ' + window.innerWidth)
    // console.log('innerHeight = ' + window.innerHeight)
    if (window.innerWidth < 500 && window.innerHeight > 650) {
      // console.log("disini")
      this.setState({ flagPotraitPhone: true })
    } else if (window.innerWidth > 700 && window.innerHeight > 500) {
      // console.log("disini 1")
      this.setState({ flagPotraitPhone: true })
    } else {
      // console.log("disini 2")
      this.setState({ flagPotraitPhone: false })
    }
    // console.log('innerWidth = ' + this.state.width)
    // console.log('innerHeight = ' + this.state.height)
  }

  render() {
    return (
      <div>
        <nav className="fixed top-0 w-full z-10 shadow-md">
          <div className="flex p-4 bg-gray-300 text-lg text-white font-semibold items-center">Radio</div>
        </nav>
        <div className="p-4 mt-16">
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
            <div className="rounded-xl shadow-md">
              <div className="h-[165px] overflow-hidden">
                <div className="w-full h-44 bg-gray-300 rounded-xl animate-pulse"></div>
              </div>
              <div className="p-2 animate-pulse">
                <div className="w-28 h-4 bg-gray-300 rounded-full"></div>
                <div className="w-36 h-4 mt-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>
            <div className="rounded-xl shadow-md">
              <div className="h-[165px] overflow-hidden">
                <div className="w-full h-44 bg-gray-300 rounded-xl animate-pulse"></div>
              </div>
              <div className="p-2 animate-pulse">
                <div className="w-28 h-4 bg-gray-300 rounded-full"></div>
                <div className="w-36 h-4 mt-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>
            <div className="rounded-xl shadow-md">
              <div className="h-[165px] overflow-hidden">
                <div className="w-full h-44 bg-gray-300 rounded-xl animate-pulse"></div>
              </div>
              <div className="p-2 animate-pulse">
                <div className="w-28 h-4 bg-gray-300 rounded-full"></div>
                <div className="w-36 h-4 mt-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>
            <div className="rounded-xl shadow-md">
              <div className="h-[165px] overflow-hidden">
                <div className="w-full h-44 bg-gray-300 rounded-xl animate-pulse"></div>
              </div>
              <div className="p-2 animate-pulse">
                <div className="w-28 h-4 bg-gray-300 rounded-full"></div>
                <div className="w-36 h-4 mt-2 bg-gray-300 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Bottom Menu --> */}
        {this.state.flagPotraitPhone && (
          <div className="fixed bottom-0 w-full bg-white rounded-t-2xl py-3 drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)] z-50">
            <div className="grid grid-cols-5">
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center animate-pulse">
                <center>
                  <div className="flex flex-col relative">
                    <div className="w-[52px] h-[52px] bg-gray-300 rounded-full drop-shadow-md p-3 items-center absolute top-[-35px] left-[-1px]"></div>
                    <div className="w-12 h-3 mt-[29px] bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        )}
        {/* <!-- End Bottom Menu --> */}
        <div className={this.state.width > '650' && this.state.height < '500' && 'fixed bottom-6 right-6 z-50 h-14 w-14 bg-gray-300 animate-pulse rounded-full items-center shadow-lg block'}></div>
        <div className={this.state.width < '500' && this.state.height > '650' && 'fixed bottom-6 right-6 z-50 h-14 w-14 bg-gray-300 animate-pulse rounded-full items-center shadow-lg hidden'}></div>
      </div>
    )
  }
}

export default SkeletonRadio
